import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import {
  DescriptionOutlined,
  Logout,
  VpnKey,
  Dashboard,
  AccountTree,
  Build,
} from "@mui/icons-material";
import { SidebarButton } from "./SideBarButton";
import { Logo } from "./Logo";
import { TenantSelector } from "./TenantSelector";

export const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth0();

  const SidebarList = () => (
    <Box
      sx={{
        width: 100,
        bgcolor: "#141414",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      role="presentation"
    >
      <Box mt={2}>
        <Logo />
        <Box sx={{ mt: 2, px: 1 }}>
          <TenantSelector />
        </Box>
      </Box>

      <Box>
        <List
          sx={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <SidebarButton
            link="/secrets"
            label="Segredos"
            currentPath={location.pathname}
            onClick={() => navigate("/secrets")}
          >
            <VpnKey sx={{ color: "white" }} />
          </SidebarButton>

          <SidebarButton
            link="/forms"
            label="Formulários"
            currentPath={location.pathname}
            onClick={() => navigate("/forms")}
          >
            <DescriptionOutlined sx={{ color: "white" }} />
          </SidebarButton>

          <SidebarButton
            link="/modeler"
            label="Modelador"
            currentPath={location.pathname}
            onClick={() => navigate("/modeler")}
          >
            <Build sx={{ color: "white" }} />
          </SidebarButton>

          <SidebarButton
            link="/process-instances"
            label="Processos"
            currentPath={location.pathname}
            onClick={() => navigate("/process-instances")}
          >
            <AccountTree sx={{ color: "white" }} />
          </SidebarButton>

          <SidebarButton
            link="/dashboards"
            label="Dashboards"
            currentPath={location.pathname}
            onClick={() => navigate("/dashboards")}
          >
            <Dashboard sx={{ color: "white" }} />
          </SidebarButton>
        </List>
      </Box>

      <Box
        sx={{
          flexGrow: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 2,
        }}
      >
        <SidebarButton
          link="#"
          label="Sair"
          currentPath={location.pathname}
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        >
          <Logout sx={{ color: "white" }} />
        </SidebarButton>
      </Box>
    </Box>
  );

  return (
    <nav
      style={{
        position: "fixed",
        height: "100%",
        top: 0,
        left: 0,
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <SidebarList />
      </Box>
    </nav>
  );
};
